export default "__VITE_ASSET__CrbP6MsE__"